module.exports = __webpack_public_path__ + "img/uk-hotels-2.b3efbeb3.png";